import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Action
export const fetchSupervisorDetail = createAsyncThunk("fetchSupervisorDetail", async (uuid, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`supervisors/${uuid}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue({
			message: error?.response?.data?.message || "Failed to fetch supervisor details",
			apiStatus: error?.response?.data?.status,
		});
	}
});

const SupervisorDetailSlice = createSlice({
	name: "SupervisorDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		apiStatus: null,
	},
	reducers: {
		resetSupervisorDetail: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
			state.apiStatus = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchSupervisorDetail.pending, (state) => {
			state.isLoading = true;
			state.error = null;
			state.apiStatus = null;
		});

		builder.addCase(fetchSupervisorDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.error = null;
			state.apiStatus = null;
		});

		builder.addCase(fetchSupervisorDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.data = null;
			state.error = action.payload?.message ?? action.error?.message ?? "Failed to fetch supervisor details";
			state.apiStatus = action.payload?.apiStatus ?? null;
		});
	},
});

export const { resetSupervisorDetail } = SupervisorDetailSlice.actions;

export default SupervisorDetailSlice.reducer;
